export default __webpack_public_path__ + "static/xometry-go-green-9b9875adf93ff4fb1e112f6ce9a92325.svg";